import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/error.png'
import _imports_1 from '@/assets/img/copy.png'
import _imports_2 from '@/assets/img/try-again-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-d43c9f56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-section" }
const _hoisted_2 = { class: "error-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "error-icon",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "error-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ไม่สามารถโหลดข้อมูลได้", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "copy-icon",
  src: _imports_1
}, null, -1))
const _hoisted_7 = { class: "btn-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "try-icon",
  src: _imports_2
}, null, -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", null, "กรุณาโหลดหน้าใหม่ อีกครั้ง (" + _toDisplayString(_ctx.errorCode) + ")", 1)
      ]),
      _createElementVNode("div", {
        class: "ref-code",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.copyTextToClipboard(_ctx.refCode)))
      }, [
        _createTextVNode(" Ref code: " + _toDisplayString(_ctx.refCode) + " ", 1),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("button", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.onRefresh()))
        }, " ลองอีกครั้ง ")
      ])
    ])
  ]))
}